export default "__VITE_ASSET__BHX0duhK__"